import FormElementConsumablePicker from '@/components/FormElementConsumablePicker/FormElementConsumablePicker';

export default FormElementConsumablePicker;
